import React from 'react';

import Input_Primary from '../Input_Primary/Input_Primary';
import { useUser } from '@/store';

interface Input_LastNameProps {
	lastName: string;
	setLastName: (lastName: string) => void;
}

const Input_LastName = ({ lastName, setLastName }: Input_LastNameProps) => {
	const user = useUser();

	React.useEffect(() => {
		if (user?.lastName) {
			setLastName(user.lastName);
		}
	}, [user]);
	return (
		<Input_Primary
			inputProps={{
				id: 'lastName',
				type: 'text',
				name: 'lastName',
				placeholder: 'Last Name',
				defaultValue: lastName || '',
				value: lastName || '',
				onChange: (e) => {
					setLastName(e.target.value);
				},
			}}
			// error={true}
			label="Last Name*"
			labelProps={{
				htmlFor: 'lastName',
			}}
		/>
	);
};

export default Input_LastName;
